import { sql } from "drizzle-orm";
import { index, pgTable, text, timestamp } from "drizzle-orm/pg-core";

// ---- chat -----------------------------------------------------------------------
// Chat messages, mutes, reports and presence live in DynamoDB (the stage's `Chat` table,
// docs/chat.md), not here. Postgres holds only what a tenant deletion needs to reach them.

/**
 * A tombstone per tenant or sandbox deletion: the environment ids whose chat items the daily
 * `ChatPurge` cron deletes from DynamoDB, which does not cascade from `DELETE FROM tenant`.
 * Inserted in the deleting transaction, completed by the cron, never deleted.
 *
 * One tombstone per environment since live breaks: `live_break_ids` are that environment's live
 * breaks, read before the cascade took them, whose `live-break-{id}` rooms the cron purges beside
 * `CHAT_ROOM_IDS`. Older tombstones may name several environments and no live breaks.
 *
 * Writer: deleteTenant / deleteSandbox (insert), the chat purge cron (completed_at, error).
 * No foreign keys: the tenant row is gone by the time the cron reads this. Platform-only.
 */
export const chatPurges = pgTable(
  "chat_purges",
  {
    id: text("id").primaryKey(), // ulid
    tenantId: text("tenant_id").notNull(),
    environmentIds: text("environment_ids").array().notNull(),
    liveBreakIds: text("live_break_ids").array().notNull().default(sql`'{}'::text[]`),
    requestedAt: timestamp("requested_at", { withTimezone: true }).notNull().defaultNow(),
    completedAt: timestamp("completed_at", { withTimezone: true }),
    error: text("error"),
  },
  (t) => [index("chat_purges_pending_idx").on(t.requestedAt).where(sql`${t.completedAt} is null`)],
);
